import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from "../../services/login/login.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { StateService } from "../../services/state/state.service";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { CONFIG } from '../../constants/constants';
import { OfflineService } from '../../services/data/offline.service';
import { State } from '../../model/state';

//Variable del global scope para utilizar jquery
declare var $: any;


@Component({
  selector: 'app-end-test',
  templateUrl: './end-test.component.html',
  styleUrls: ['./end-test.component.css']
})
//Controlador de la pagina end-test.html se encarga de finalizar un examen
export class EndTestComponent implements OnInit {

  //Variable para msotrar el mensaje de finalización
  public showDownloadMessage: Boolean;

  // Guardar el typeTest al inicializar
  public typeTest: string = '2';

  //Constructor de la clase
  constructor(private _router: Router,
    private _translateService: TranslateService,
    private _configurationService: ConfigurationService,
    public _configurationControlService: ConfigurationControlService,
    private _loginService: LoginService,
    private _welcomeDataService: WelcomeService,
    private _tokenController: TokenControlService,
    private _stateService: StateService,
    private _routingValidationService: RoutingValidationService,
    private _offlineService: OfflineService,
    private _welcomeService: WelcomeService) {
    this._translateService.addLangs(["es", "en"]);
    // Verificar que examConfiguration existe antes de acceder a sus propiedades
    const defaultLang = _configurationControlService.examConfiguration?.language || 'es';
    this._translateService.setDefaultLang(defaultLang);
    this._translateService.use(defaultLang);
    // Guardar typeTest antes de que se limpie
    this.typeTest = _configurationControlService.examConfiguration?.typeTest || '2';
  }

  //Necesario debido a implementacion de interfaz OnInit
  //Metodo que se ejecuta al iniciar esta vista
  ngOnInit() {
    console.log('EndTestComponent ngOnInit - typeTest:', this.typeTest);

    this._configurationService.inhabilitarBotonAtras();
    let self = this;

    if (this._configurationControlService.downloadFile) {
      this.showDownloadMessage = true;
    } else {
      this.showDownloadMessage = false;
    }

    console.log('Verificando typeTest:', this.typeTest);

    // Solo auto-ejecutar aceptar() si es typeTest == '2' (adaptativo)
    if (this.typeTest == '2') {
      console.log('typeTest es 2, llamando a aceptar()');

      if (this._configurationControlService.ambiente == "preIcfes") {
        this._router.navigate(['/welcomePreIcfes']);
      } else {
        this.aceptar();
      }
    } else {
      // Para typeTest == '1' (normal), el usuario hace clic en el botón
      console.log('typeTest es 1, esperando clic del usuario en el botón');
    }
  }


  //Se encarga de redirigir a la pagina de login
  //Se encarga de redirigir a la pagina de login
  public aceptar() {
    console.log('--- Depuración de aceptar() ---');
    console.log('CONFIG.ONLINE:', CONFIG.ONLINE);
    console.log('Estado actual (state):', this._stateService.state);
    console.log('Datos de bienvenida (welcomeData):', this._welcomeDataService.data);
    console.log('Sesión actual:', this._stateService.state ? this._stateService.state.sesion : 'null');
    console.log('Total sesiones:', this._welcomeDataService.data?.sessions ? this._welcomeDataService.data.sessions.length : 'null');

    // ✅ Validar que existan los servicios necesarios
    if (!this._stateService.state || !this._welcomeDataService.data) {
      console.error('Error: State o WelcomeData no disponibles');
      this._router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    if (!CONFIG.ONLINE && this._stateService.state == null) {
      this._stateService.state = new State(1, this._tokenController.token.sesion, 1, this._offlineService.credential.idCredencial);
      console.log('Estado creado en offline:', this._stateService.state);
    }

    // Validación adicional para evitar redirección prematura
    if (!this._welcomeDataService.data.sessions || this._welcomeDataService.data.sessions.length === 0) {
      console.warn('Advertencia: sessions está vacío o no definido. Redirigiendo a /login.');
      this._router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    // Siempre calcular si es la última sesión
    const isLastSession = (this._stateService.state.sesion >= this._welcomeDataService.data.sessions.length);
    this._stateService.gotoLogin = isLastSession;

    console.log('isLastSession:', isLastSession);
    console.log('Sesión actual:', this._stateService.state.sesion);
    console.log('Total sesiones:', this._welcomeDataService.data.sessions.length);

    if (isLastSession) {
      console.log('Es la última sesión: Procediendo a logout y /login');

      // ✅ Guardar valores necesarios ANTES de limpiar
      const esDemo = this._configurationControlService.esDemo;
      const ambiente = this._configurationControlService.ambiente;
      const idCombo = this._welcomeService.data?.idCombo;

      // Lógica para última sesión: logout y encuesta si aplica
      this._routingValidationService.validateRouting("logOut");

      // Abrir encuesta si aplica
      if (idCombo == "721") {
        window.open("https://icfes.eu.qualtrics.com/jfe/form/SV_3VjIF9CqJqfTduB", "_blank");
      }
      $("body").css("background-image", "").css("background-repeat", "repeat");

      // ✅ Determinar ruta ANTES de limpiar
      let targetRoute = '/login';
      if (esDemo) {
        targetRoute = (ambiente == "demo") ? '/demo' : '/preIcfes';
      }

      console.log('Redirigiendo a:', targetRoute);

      // ✅ Limpiar el estado ANTES de navegar
      try {
        this._stateService.deadLine = null;
        this._tokenController.token = null;
        // this._configurationControlService.examConfiguration = null;
        console.log('Estado limpiado antes de navegación');
      } catch (e) {
        console.error('Error limpiando estado:', e);
      }

      // ✅ Navegar UNA SOLA VEZ
      this._router.navigate([targetRoute], { replaceUrl: true }).then(() => {
        console.log('Navegación exitosa a:', targetRoute);
      }).catch(error => {
        console.error('Error en navegación:', error);
        // Fallback: intentar navegar a login directamente
        this._router.navigate(['/login'], { replaceUrl: true });
      });

    } else {
      // Hay sesiones pendientes: redirigir a welcome
      console.log('Sesiones pendientes: Redirigiendo a /welcome');

      if (CONFIG.ONLINE) {
        this._loginService.loadWelcomeInfo(
          this._tokenController.token.credentialId,
          this._tokenController.token.token,
          this._tokenController.token.tokenId,
          true
        ).then(res => {
          console.log('Datos de welcome actualizados:', res);
          this._welcomeDataService.data = res;
          this._stateService.deadLine = null;
          this._router.navigate(['/welcome']);
        }).catch(error => {
          console.error('Error cargando welcome info online:', error);
          this._router.navigate(['/login'], { replaceUrl: true });
        });
      } else {
        // Modo offline
        this._tokenController.token.sesion += 1;
        this._stateService.state.sesion += 1;
        this._offlineService.getWelcomeDTO(
          this._tokenController.token.credentialId,
          this._tokenController.token.token,
          this._tokenController.token.tokenId,
          this._tokenController.token.sesion
        ).then(res => {
          console.log('Datos de welcome offline:', res);
          this._welcomeDataService.data = res;
          this._stateService.deadLine = null;
          this._router.navigate(['/welcome']);
        }).catch(error => {
          console.error('Error cargando welcome info offline:', error);
          this._router.navigate(['/login'], { replaceUrl: true });
        });
      }
    }
  }
}

